import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { CheckVersionConfig } from './check-version.model';

export const CHECK_VERSION_CONFIG = new InjectionToken<CheckVersionConfig>('CHECK_VERSION_CONFIG');

export function provideCheckVersion(config: CheckVersionConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: CHECK_VERSION_CONFIG,
      useValue: config,
    },
  ]);
}
